import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { MessengerService } from '@services/messenger/messenger.service';
import { DialogService } from '@services/dialog/dialog.service';
import moment from 'moment';

@Component({
    selector: 'app-cleanup-customer-execute',
    templateUrl: './cleanup-customer-execute.component.html',
    styleUrls: ['./cleanup-customer-execute.component.scss'],
    standalone: false
})
export class CleanupCustomerExecuteComponent implements OnInit {

  public title = 'Organisations';
  public pageActions: PageAction[];

  public organisationId;
  public data;
  public initialData;
  public isLoading = true;
  public deletionDone = false;
  private deletionDate;

  constructor(private http: HttpClient, private route: ActivatedRoute, private ms: MessengerService, private dialog: DialogService, private router: Router) {
    this.organisationId = this.route.snapshot.params['id'];
  }

  async ngOnInit() {
    const options = { headers: { 'authentication': this.ms.basicMessengerService.getAuthenticationHeader() } };
    options['params'] = { id: this.organisationId }
    this.data = await this.http.get(`${environment[this.ms.getActiveAPI()].apiBaseURL}/cleanup/customer`, options).toPromise();
    this.initialData = JSON.parse(JSON.stringify(this.data));
    this.isLoading = false;
  }

  async onExecute(type: string) {
    let text;
    switch (type) {
      case 'analytics':
        text = 'Wollen Sie wirklich die kompletten Analytics Daten des ausgewählten Kunden löschen? Um zu bestätigen geben Sie bitte den Namen der Organisation in das Textfeld ein.';
        break;
      case 'content':
        text = 'Wollen Sie wirklich die kompletten Inhalts Daten des ausgewählten Kunden löschen? Um zu bestätigen geben Sie bitte den Namen der Organisation in das Textfeld ein.';
        break;
      case 'customer':
        text = 'Wollen Sie wirklich die kompletten Benutzer Daten des ausgewählten Kunden löschen? Um zu bestätigen geben Sie bitte den Namen der Organisation in das Textfeld ein.';
        break;
    }
    const dialogRes = await this.dialog.confirm(text, 'Daten löschen', true);
    if (dialogRes !== this.data.Organisation.title.trim()) {
      return;
    }
    this.isLoading = true;
    const options = { headers: { 'authentication': this.ms.basicMessengerService.getAuthenticationHeader() } };
    options['params'] = { id: this.organisationId, type }
    await this.http.delete(environment.apiBaseURL + '/cleanup/customer', options).toPromise();
    if (type === 'customer') {
      this.data = null;
    } else {
      this.data = await this.http.get(environment.apiBaseURL + '/cleanup/customer', options).toPromise();
    }
    if (type === 'customer') {
      this.deletionDone = true;
      this.deletionDate = moment();
    }

    this.isLoading = false;
  }

  isDisabled(type) {
    switch (type) {
      case 'content':
        return !!this.data?.analytics || !!this.data?.dailyAnalyticLogByTimestamp || !!this.data?.dailyAnalyticLog;
      case 'customer':
        return !!this.data?.appIds || !!this.data?.widgetIds || !!this.data?.dynamicContentEntrances || !!this.data?.dynamicContents || !!this.data?.filePaths?.imagePaths?.length
          || !!this.data?.filePaths?.videoPaths?.length || !!this.data?.filePaths?.filePaths?.length || !!this.data?.filePaths?.mediaPaths?.length;

    }

  }

  back() {
    this.router.navigate(['cleanup-customer']);
  }

  downloadProtocol() {
    let csvString = 'Löschprotokoll: ' + this.initialData.Organisation.title + '\n';
    csvString += 'OrganisationsCustomer\t' + this.initialData.OrganisationCustomer.organisationName + '\n';
    csvString += 'Groups\t' + this.initialData.groups + '\n';
    csvString += 'Group Connections\t' + this.initialData.groupConnections + '\n';
    csvString += 'Content Connections\t' + this.initialData.contentConnections + '\n';
    csvString += 'Secured Connections\t' + this.initialData.securedConnections + '\n';
    csvString += 'Profiles\t' + this.initialData.profiles + '\n';
    csvString += 'FrontProfiles\t' + this.initialData.frontProfiles + '\n';
    csvString += 'FrontProfile Connections\t' + this.initialData.frontProfileConnections + '\n';
    csvString += 'Accounts\t' + this.initialData.accounts + '\n';
    csvString += 'Devices\t' + this.initialData.devices + '\n';
    csvString += 'Sessions\t' + this.initialData.sessions + '\n';
    csvString += 'Compositions\t' + this.initialData.compositionTitles.join(', ') + '\n';
    csvString += 'Composition Apps\t' + this.initialData.compositionApps + '\n';
    csvString += 'Imports\t' + this.initialData.imports + '\n';
    csvString += 'Packages\t' + this.initialData.packageTitles.join(', ') + '\n';
    csvString += 'Package Ids\t' + this.initialData.packageIds.join(', ') + '\n';
    csvString += 'Package Apps\t' + this.initialData.appIds + '\n';
    csvString += 'Package Widgets\t' + this.initialData.widgetIds + '\n';
    csvString += 'Dynamic Content Entrances\t' + this.initialData.dynamicContentEntrances + '\n';
    csvString += 'Dynamic Contents\t' + this.initialData.dynamicContents + '\n';
    csvString += 'Documents\t' + (this.initialData.filePaths?.filePaths.length || 0) + '\n';
    csvString += 'Images\t' + (this.initialData.filePaths?.imagePaths.length || 0) + '\n';
    csvString += 'Videos\t' + (this.initialData.filePaths?.videoPaths.length || 0) + '\n';
    csvString += 'Other media\t' + (this.initialData.filePaths?.mediaPaths.length || 0) + '\n';
    csvString += 'Analytic Logs\t' + this.initialData.analytics + '\n';
    csvString += 'Analytic Computed Logs\t' + this.initialData.dailyAnalyticLogByTimestamp + '\n';
    csvString += 'Analytic Computed Logs Old\t' + this.initialData.dailyAnalyticLog + '\n\n';
    const date = this.deletionDate || moment();
    csvString += 'Gelöscht am:\t' + date.format('DD.MM.YYYY HH:mm');

    const link = document.createElement('a');
    link.href = URL.createObjectURL(new Blob([csvString], { type: 'data:text/csv;charset=utf-8;' }));
    link.style.visibility = 'hidden';
    link.download = 'Löschprotokoll ' + this.initialData.Organisation.title + '.csv';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
